/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Brands_PlaydataInputs */

const ja_home_brands_playdata = /** @type {(inputs: Home_Brands_PlaydataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Playdata`)
};

const en_home_brands_playdata = /** @type {(inputs: Home_Brands_PlaydataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Playdata`)
};

/**
* | output |
* | --- |
* | "Playdata" |
*
* @param {Home_Brands_PlaydataInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const home_brands_playdata = /** @type {((inputs?: Home_Brands_PlaydataInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Brands_PlaydataInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_home_brands_playdata(inputs)
	return en_home_brands_playdata(inputs)
});